import { Injectable } from '@angular/core';
import { ApiService } from '../../../@core/utils/api.service';

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  bookingUrl = 'booking';
  bookingDetailsUrl = 'booking-details';

  constructor(private apiService: ApiService) {}

  public getBooking(company: string, file: string) {
    return this.apiService.get(`${this.bookingUrl}/${company}/${file}`);
  }

  public getBookingDetails(bookingId: string, companyId: string) {
    return this.apiService.get(`${this.bookingDetailsUrl}/${bookingId}/${companyId}`);
  }

  public getBookingReport(bookingId: string, companyId: string) {
    return this.apiService.get(`${this.bookingUrl}-report/${bookingId}/${companyId}`);
  }

  public getAllFileItineraries(bookingId: string, companyId: string) {
    return this.apiService.get(`itineraries/${bookingId}/${companyId}`);
  }

  public getBookingDocuments(fileId: string, companyId: string) {
    return this.apiService.get(`file-documents/${fileId}/${companyId}`);
  }

  public downloadLink(id: string, companyId: string) {
    return this.apiService.get(`document/${id}/${companyId}`);
  }
}
